import PublicApiService from "../../../services/PublicApiService";
import { useEffect, useState } from "react";
import { EventAutocompleteOption } from "../types";
import jwtUtils from "../../../common/utils/jwtUtils";
import authorizationStore from "../../../common/auth/authorizationStore";
import { MercuryEvents } from "../../../services/types";
import EventHelper from "../../../common/network/helpers/event/EventHelper";

export const useGetMercuryShows = () => {
  const [options, setOptions] = useState<EventAutocompleteOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    EventHelper.mercuryEventOptions = options;
  }, [options.length]);

  const filterByBuAdmin = (eventEditions: MercuryEvents[], buIds: string[]) => {
    const buAdminEvents: EventAutocompleteOption[] = [];
    eventEditions.forEach(event => {
      const availableEvent = buIds.find(e => e === event.businessUnitId);
      if (availableEvent) {
        buAdminEvents.push({ ...event, label: event.name });
      }
    });
    setOptions(buAdminEvents);
  };

  const filterByRxAdmin = (eventEditions: MercuryEvents[]) => {
    setOptions(eventEditions.map(event => ({ label: event.name, ...event, endDate: event.endDate })));
  };

  const filterByStaff = (eventEditions: MercuryEvents[], onSiteEe: string[]) => {
    const staffEvents: EventAutocompleteOption[] = [];
    eventEditions.forEach(event => {
      const availableEvent = onSiteEe.find(e => e === event.gbsCode);
      if (availableEvent) {
        staffEvents.push({ ...event, label: event.name });
      }
    });
    setOptions(prevState => ([...prevState, ...staffEvents]));
  };

  const filterEvents = async (eventEditions: MercuryEvents[]) => {
    const token = await authorizationStore.getToken();
    if (jwtUtils.isLoggedUserRxAdmin(token)) {
      filterByRxAdmin(eventEditions);
      return;
    }

    const buIds = jwtUtils.getBuIdsFromToken(token);
    if (buIds) {
      filterByBuAdmin(eventEditions, buIds);
      return;
    }

    const staffOnsiteEe = jwtUtils.getStaffOnSiteEe(token);
    if (staffOnsiteEe) {
      filterByStaff(eventEditions, staffOnsiteEe);
    }

    const managerEvents = jwtUtils.getEventsFromToken(token, 'rxOnsiteManagerEe');
    if (managerEvents) {
      filterByStaff(eventEditions, managerEvents);
    }

    const financeEvents = jwtUtils.getEventsFromToken(token, 'rxOnsiteFinanceEe');
    if (financeEvents) {
      filterByStaff(eventEditions, financeEvents);
    }
  };

  const getMercuryShows = async () => {
    try {
      const eventsResponse = await PublicApiService.getSupportedMercuryShows()
      await filterEvents(eventsResponse.eventEditions);
    } catch(e) {
      setError(true);
    }
    setLoading(false);
  };

  return { getMercuryShows, options, loading, error };
};
